export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode == 'dark';

  return {
    linkExtensionBody: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75rem',
      width: {
        xs: '343px',
        sm: '90%',
        md: '560px',
      },
      maxWidth: {
        xs: '343px',
        sm: '90%',
        md: '560px',
      },
      height: { xs: '90vh', md: '691px' },
      maxHeight: { xs: '90vh', md: '691px' },
      minHeight: 0,
      p: '1rem',
      bgcolor: theme?.palette?.background?.paper,
      borderRadius: '0.5rem',
      boxShadow: isDark
        ? '0px 12px 36px rgba(0, 0, 0, 0.48)'
        : '0px 8px 32px rgba(0, 0, 0, 0.16)',
      boxSizing: 'border-box',
      overflow: 'hidden',
      outline: 'none',
      fontFamily: theme?.typography?.fontFamily,
    },
    modalActions: {
      display: 'flex',
      flexShrink: 0,
      justifyContent: 'flex-end',
      gap: '1rem',
      mt: 'auto',
    },
    cancelButton: {
      height: '42px',
      width: '90px',
    },
    convertButton: {
      height: '42px',
      width: '97px',
    },
  };
};
